import React, {forwardRef, useImperativeHandle, useState, useEffect, useRef,} from 'react';
import { useForm } from "react-hook-form"


import Dialog, { DialogRef } from "../../../components/Dialog";

export interface KessanDialogRef extends DialogRef {
  set: (values:KessanDialogValues) => void;
  clear: () => void;
}
export type KessanDialogValues = {
  typeOfBudgetKessanItemList: string[];
  runningTitleKessanItemList1: string[];
  runningTitleKessanItemList2: string[];
}
type KessanDialogProps = {
    id: string;
    values?: KessanDialogValues;
    onClose: (formData:any) => void;
};
const KessanDialog = forwardRef((props:KessanDialogProps, ref: React.Ref<KessanDialogRef> | undefined) => {
    
  const control = React.useRef<DialogRef>(null);
  
  const { register, getValues, watch, setValue } = useForm<KessanDialogValues>();

  const defaultValues = {
    'typeOfBudgetKessanItemList': [],
    'runningTitleKessanItemList1': [],
    'runningTitleKessanItemList2': []
  }
  const { id, values = defaultValues, onClose } = props;

  // チェック判定
  const isChecked = (list:string[], value: string) => {
    if (!list) return false;
    let check = false;
    list.map(function(v:string) {
        if (value === v) {
          check = true;
        }
    });
    return check;
  }

  // クリア処理
  const handleClear = () => {
    setValue('typeOfBudgetKessanItemList', []);
    setValue('runningTitleKessanItemList1', []);
    setValue('runningTitleKessanItemList2', []);
  }
  // クローズイベント処理
  const handleClose = () => {
    const values = getValues();
    
    // 未チェックや単独チェックの場合
    // 配列として値が取れないため形式を変換する。
    let typeOfBudgetKessanItemList:string[] = [];
    if (typeof values.typeOfBudgetKessanItemList == 'object') {
      typeOfBudgetKessanItemList = values.typeOfBudgetKessanItemList;
    } else {
      typeOfBudgetKessanItemList = [values.typeOfBudgetKessanItemList];
    }
    let runningTitleKessanItemList1:string[] = [];
    if (typeof values.runningTitleKessanItemList1 == 'object') {
      runningTitleKessanItemList1 = values.runningTitleKessanItemList1;
    } else {
      runningTitleKessanItemList1 = [values.runningTitleKessanItemList1];
    }
    let runningTitleKessanItemList2:string[] = [];
    if (typeof values.runningTitleKessanItemList2 == 'object') {
      runningTitleKessanItemList2 = values.runningTitleKessanItemList2;
    } else {
      runningTitleKessanItemList2 = [values.runningTitleKessanItemList2];
    }

    onClose({
    'typeOfBudgetKessanItemList': typeOfBudgetKessanItemList,
    'runningTitleKessanItemList1': runningTitleKessanItemList1,
    'runningTitleKessanItemList2': runningTitleKessanItemList2
  });
  }

  // 表示制御
  const isFirestRender = useRef(true);
  const watchTypeOfBudgetKessanItemList:string[] = watch('typeOfBudgetKessanItemList', defaultValues.typeOfBudgetKessanItemList);
  const [viewRunningTitlteKessanItemList1, setViewRunningTitlteKessanItemList1] = useState<boolean>(false);
  const [viewRunningTitlteKessanItemList2, setViewRunningTitlteKessanItemList2] = useState<boolean>(false);
  useEffect(() => {
    if (isFirestRender.current) { // 初回レンダリングをスキップ
      isFirestRender.current = false;
      return;
    }

    // 未チェックや単独チェックの場合
    // 配列として値が取れないため形式を変換する。
    let list:string[] = [];
    if (typeof watchTypeOfBudgetKessanItemList == 'object') {
      list = watchTypeOfBudgetKessanItemList;
    } else {
      list = [watchTypeOfBudgetKessanItemList];
    }

    // 一般会計
    if (isChecked(list, "5")) {
      setViewRunningTitlteKessanItemList1(true);
    } else {
      setViewRunningTitlteKessanItemList1(false);
      setValue('runningTitleKessanItemList1', []);
    }
    // 特別会計
    if (isChecked(list, "6")) {
      setViewRunningTitlteKessanItemList2(true);
    } else {
      setViewRunningTitlteKessanItemList2(false);
      setValue('runningTitleKessanItemList2', []);
    }
  }, [watchTypeOfBudgetKessanItemList]);

  // 
  useImperativeHandle(ref, () => ({
      show: () => {
        control.current?.show();
      },
      close: () => {
        control.current?.close();
      },
      set: (values: KessanDialogValues) => {
        setValue('typeOfBudgetKessanItemList', values.typeOfBudgetKessanItemList);
        setValue('runningTitleKessanItemList1', values.runningTitleKessanItemList1);
        setValue('runningTitleKessanItemList2', values.runningTitleKessanItemList2);
      },
      clear: () => {
        handleClear();
      }
  }));


    return (
        <Dialog id={id} ref={control} onClose={handleClose} onClear={handleClear}>
        <form>
          <div className="c-blk-head c-flex c-flex--between u-mt-0">
            <h2 id="finalAccountDocModalTitle" className="c-heading-lv2 c-flex__grow">決算書情報の絞り込み</h2>
          </div>
          <div className="c-blk-head">
            <h3 className="c-heading-lv3">冊子名で絞り込み</h3>
          </div>
          <div className="c-blk-txt">
            <p>検索対象に絞り込む冊子名をチェックしてください。</p>
          </div>
          <div className="c-blk-txt">
            <ul className="c-list-annotation">
              <li className="c-text-note">※冊子を指定しない場合、全ての冊子が検索対象となります。</li>
              <li className="c-text-note">※決算参照、特別会計決算参照書のいずれかを選択した場合、所管（国会、会計検査院、財務省等）による絞り込みの指定が可能です。</li>
            </ul>
          </div>
          <div className="c-blk-txt c-blk-txt--lg">
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                決算書情報の冊子名
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col2">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_0" value="0" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "0")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_0">一般会計歳入歳出決算</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_1" value="1" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "1")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_1">国税収納金整理資金受払計算書</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_2" value="2" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "2")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_2">決算調整資金からの歳入組入れに関する調書</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_3" value="3" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "3")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_3">特別会計歳入歳出決算</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_4" value="4" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "4")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_4">政府関係機関決算書</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_5" value="5" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "5")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_5">決算参照</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_6" value="6" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "6")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_6">特別会計決算参照書</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_7" value="7" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "7")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_7">物品増減及び現在額総報告</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_8" value="8" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "8")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_8">各省各庁物品増減及び現在額報告書</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_9" value="9" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "9")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_9">国の債権の現在額総報告</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetKessanItemList_10" value="10" defaultChecked={isChecked(values.typeOfBudgetKessanItemList, "10")} {...register('typeOfBudgetKessanItemList')}/>
                    <label htmlFor="typeOfBudgetKessanItemList_10">各省各庁債権現在額報告書</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell"></div>
              </div>
            </fieldset>
          </div>
          <div className="c-blk-head">
            <h3 className="c-heading-lv3">所管で絞り込み</h3>
          </div>
          <div className="c-blk-txt">
            <p>検索対象に絞り込む所管をチェックしてください。</p>
          </div>
          <div className="c-blk-txt">
            <ul className="c-list-annotation">
              <li className="c-text-note">※冊子名の決算参照、特別会計決算参照書のいずれかを選択した場合のみ、所管による絞り込みの指定が可能です。</li>
            </ul>
          </div>
          <div className="c-blk-txt c-blk-txt--lg" style={{display: (viewRunningTitlteKessanItemList1)?'': 'none'}}>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                決算書情報「決算参照」の所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_0" value="0" defaultChecked={isChecked(values.runningTitleKessanItemList1, "0")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_0">皇室費</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_1" value="1" defaultChecked={isChecked(values.runningTitleKessanItemList1, "1")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_1">国会</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_2" value="2" defaultChecked={isChecked(values.runningTitleKessanItemList1, "2")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_2">裁判所</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_3" value="3" defaultChecked={isChecked(values.runningTitleKessanItemList1, "3")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_3">会計検査院</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_4" value="4" defaultChecked={isChecked(values.runningTitleKessanItemList1, "4")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_4">内閣</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_5" value="5" defaultChecked={isChecked(values.runningTitleKessanItemList1, "5")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_5">内閣府</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_6" value="6" defaultChecked={isChecked(values.runningTitleKessanItemList1, "6")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_6">デジタル庁</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_30" value="30" defaultChecked={isChecked(values.runningTitleKessanItemList1, "30")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_30">防災庁</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_7" value="7" defaultChecked={isChecked(values.runningTitleKessanItemList1, "7")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_7">復興庁</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_8" value="8" defaultChecked={isChecked(values.runningTitleKessanItemList1, "8")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_8">総務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_9" value="9" defaultChecked={isChecked(values.runningTitleKessanItemList1, "9")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_9">法務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_10" value="10" defaultChecked={isChecked(values.runningTitleKessanItemList1, "10")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_10">外務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_11" value="11" defaultChecked={isChecked(values.runningTitleKessanItemList1, "11")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_11">財務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_12" value="12" defaultChecked={isChecked(values.runningTitleKessanItemList1, "12")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_12">文部科学省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_13" value="13" defaultChecked={isChecked(values.runningTitleKessanItemList1, "13")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_13">厚生労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_14" value="14" defaultChecked={isChecked(values.runningTitleKessanItemList1, "14")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_14">農林水産省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_15" value="15" defaultChecked={isChecked(values.runningTitleKessanItemList1, "15")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_15">経済産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_16" value="16" defaultChecked={isChecked(values.runningTitleKessanItemList1, "16")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_16">国土交通省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_17" value="17" defaultChecked={isChecked(values.runningTitleKessanItemList1, "17")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_17">環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_18" value="18" defaultChecked={isChecked(values.runningTitleKessanItemList1, "18")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_18">防衛省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell"></div>
              </div>
            </fieldset>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                決算書情報「決算参照」の旧所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3 c-checkbox-table-body--gray">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_19" value="19" defaultChecked={isChecked(values.runningTitleKessanItemList1, "19")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_19">総理府</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_20" value="20" defaultChecked={isChecked(values.runningTitleKessanItemList1, "20")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_20">大蔵省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_21" value="21" defaultChecked={isChecked(values.runningTitleKessanItemList1, "21")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_21">文部省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_22" value="22" defaultChecked={isChecked(values.runningTitleKessanItemList1, "22")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_22">厚生省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_23" value="23" defaultChecked={isChecked(values.runningTitleKessanItemList1, "23")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_23">農林省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_24" value="24" defaultChecked={isChecked(values.runningTitleKessanItemList1, "24")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_24">通商産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_25" value="25" defaultChecked={isChecked(values.runningTitleKessanItemList1, "25")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_25">運輸省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_26" value="26" defaultChecked={isChecked(values.runningTitleKessanItemList1, "26")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_26">郵政省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_27" value="27" defaultChecked={isChecked(values.runningTitleKessanItemList1, "27")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_27">労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_28" value="28" defaultChecked={isChecked(values.runningTitleKessanItemList1, "28")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_28">建設省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList1_29" value="29" defaultChecked={isChecked(values.runningTitleKessanItemList1, "29")} {...register('runningTitleKessanItemList1')}/>
                    <label htmlFor="runningTitleKessanItemList1_29">自治省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell"></div>
              </div>
            </fieldset>
          </div>
          <div className="c-blk-txt c-blk-txt--lg" style={{display: (viewRunningTitlteKessanItemList2)?'': 'none'}}>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                決算書情報「特別会計決算参照書」の所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_0" value="0" defaultChecked={isChecked(values.runningTitleKessanItemList2, "0")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_0">総務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_1" value="1" defaultChecked={isChecked(values.runningTitleKessanItemList2, "1")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_1">法務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_2" value="2" defaultChecked={isChecked(values.runningTitleKessanItemList2, "2")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_2">財務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_3" value="3" defaultChecked={isChecked(values.runningTitleKessanItemList2, "3")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_3">文部科学省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_4" value="4" defaultChecked={isChecked(values.runningTitleKessanItemList2, "4")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_4">厚生労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_5" value="5" defaultChecked={isChecked(values.runningTitleKessanItemList2, "5")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_5">農林水産省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_6" value="6" defaultChecked={isChecked(values.runningTitleKessanItemList2, "6")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_6">経済産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_7" value="7" defaultChecked={isChecked(values.runningTitleKessanItemList2, "7")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_7">国土交通省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_8" value="8" defaultChecked={isChecked(values.runningTitleKessanItemList2, "8")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_8">内閣府、総務省及び財務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_9" value="9" defaultChecked={isChecked(values.runningTitleKessanItemList2, "9")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_9">内閣府及び厚生労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_10" value="10" defaultChecked={isChecked(values.runningTitleKessanItemList2, "10")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_10">財務省、文部科学省及び経済産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_11" value="11" defaultChecked={isChecked(values.runningTitleKessanItemList2, "11")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_11">財務省、経済産業省及び環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_12" value="12" defaultChecked={isChecked(values.runningTitleKessanItemList2, "12")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_12">財務省及び国土交通省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_13" value="13" defaultChecked={isChecked(values.runningTitleKessanItemList2, "13")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_13">文部科学省、経済産業省及び環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_14" value="14" defaultChecked={isChecked(values.runningTitleKessanItemList2, "14")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_14">内閣府、文部科学省、経済産業省及び環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_15" value="15" defaultChecked={isChecked(values.runningTitleKessanItemList2, "15")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_15">
                      国会、裁判所、会計検査院、内閣、内閣府、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省
                    </label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_16" value="16" defaultChecked={isChecked(values.runningTitleKessanItemList2, "16")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_16">
                      国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省
                    </label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_32" value="32" defaultChecked={isChecked(values.runningTitleKessanItemList2, "32")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_32">
                      国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、防災庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省
                    </label>
                  </span>
                </div>
              </div>
            </fieldset>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                決算書情報「特別会計決算参照書」の旧所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3 c-checkbox-table-body--gray">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_17" value="17" defaultChecked={isChecked(values.runningTitleKessanItemList2, "17")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_17">大蔵省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_18" value="18" defaultChecked={isChecked(values.runningTitleKessanItemList2, "18")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_18">文部省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_19" value="19" defaultChecked={isChecked(values.runningTitleKessanItemList2, "19")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_19">厚生省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_20" value="20" defaultChecked={isChecked(values.runningTitleKessanItemList2, "20")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_20">農林省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_21" value="21" defaultChecked={isChecked(values.runningTitleKessanItemList2, "21")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_21">通商産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_22" value="22" defaultChecked={isChecked(values.runningTitleKessanItemList2, "22")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_22">運輸省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_23" value="23" defaultChecked={isChecked(values.runningTitleKessanItemList2, "23")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_23">郵政省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_24" value="24" defaultChecked={isChecked(values.runningTitleKessanItemList2, "24")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_24">労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_25" value="25" defaultChecked={isChecked(values.runningTitleKessanItemList2, "25")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_25">建設省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_26" value="26" defaultChecked={isChecked(values.runningTitleKessanItemList2, "26")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_26">総理府、大蔵省及び通商産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_27" value="27" defaultChecked={isChecked(values.runningTitleKessanItemList2, "27")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_27">総理府、大蔵省及び自治省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_28" value="28" defaultChecked={isChecked(values.runningTitleKessanItemList2, "28")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_28">大蔵省及び自治省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_29" value="29" defaultChecked={isChecked(values.runningTitleKessanItemList2, "29")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_29">大蔵省、通商産業省及び労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_30" value="30" defaultChecked={isChecked(values.runningTitleKessanItemList2, "30")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_30">大蔵省及び建設省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleKessanItemList2_31" value="31" defaultChecked={isChecked(values.runningTitleKessanItemList2, "31")} {...register('runningTitleKessanItemList2')}/>
                    <label htmlFor="runningTitleKessanItemList2_31">大蔵省、運輸省及び建設省</label>
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
        </form>
        </Dialog>
    );
});
export default KessanDialog;